import { Center, Loader, Stack, Text } from '@mantine/core';
import { useTranslation } from '../hooks/useTranslation';

export interface LoadingFallbackProps {
  /** Loading message to display (optional) */
  message?: string;
  /** Size of the loader: 'xs' | 'sm' | 'md' | 'lg' | 'xl' */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /** Minimum height for the loading container */
  minHeight?: number | string;
}

/**
 * Consistent loading fallback component for Suspense boundaries.
 * Displays a centered loader with optional message.
 */
export function LoadingFallback({
  message,
  size = 'lg',
  minHeight = 200,
}: LoadingFallbackProps) {
  const { t } = useTranslation();

  return (
    <Center style={{ minHeight }} data-testid="loading-fallback">
      <Stack align="center" gap="md">
        <Loader size={size} data-testid="loading-spinner" />
        {message && (
          <Text size="sm" c="dimmed" data-testid="loading-message">
            {message}
          </Text>
        )}
        {!message && (
          <Text size="sm" c="dimmed" data-testid="loading-message">
            {t('common.loading')}
          </Text>
        )}
      </Stack>
    </Center>
  );
}
